var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleChoicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5556_14550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6004 9.9999C19.6004 4.69797 15.3023 0.399902 10.0004 0.399902C4.69846 0.399902 0.400391 4.69797 0.400391 9.9999C0.400391 15.3018 4.69846 19.5999 10.0004 19.5999C15.3023 19.5999 19.6004 15.3018 19.6004 9.9999Z",
    fill: "#656769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 0.399902C7.45431 0.399902 5.01251 1.41133 3.21217 3.21168C1.41182 5.01203 0.400391 7.45382 0.400391 9.9999C0.400391 10.2647 0.411057 10.527 0.432391 10.7867C0.629904 8.38488 1.72354 6.1452 3.4961 4.51248C5.26866 2.87975 7.59046 1.97343 10.0004 1.9735C12.4103 1.97343 14.7321 2.87975 16.5047 4.51248C18.2772 6.1452 19.3709 8.38488 19.5684 10.7867C19.5897 10.5272 19.6004 10.265 19.6004 9.9999C19.6004 7.45382 18.589 5.01203 16.7886 3.21168C14.9883 1.41133 12.5465 0.399902 10.0004 0.399902Z",
    fill: "#87898C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6004 9.9999C19.6004 4.69797 15.3023 0.399902 10.0004 0.399902C4.69846 0.399902 0.400391 4.69797 0.400391 9.9999C0.400391 15.3018 4.69846 19.5999 10.0004 19.5999C15.3023 19.5999 19.6004 15.3018 19.6004 9.9999Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.899C13.1719 16.899 15.7432 14.3277 15.7432 11.1558C15.7432 7.98392 13.1719 5.4126 10 5.4126C6.82815 5.4126 4.25684 7.98392 4.25684 11.1558C4.25684 14.3277 6.82815 16.899 10 16.899Z",
    fill: "#525252",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.7676C13.1719 15.7676 15.7432 13.1963 15.7432 10.0245C15.7432 6.85257 13.1719 4.28125 10 4.28125C6.82815 4.28125 4.25684 6.85257 4.25684 10.0245C4.25684 13.1963 6.82815 15.7676 10 15.7676Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99964 5.85517C11.3865 5.85519 12.7266 6.357 13.7723 7.26793C14.8181 8.17886 15.499 9.43741 15.6892 10.8112C15.7249 10.5504 15.7428 10.2876 15.7428 10.0244C15.7302 8.50954 15.1196 7.06104 14.0439 5.99434C12.9683 4.92763 11.5147 4.3291 9.99984 4.3291C8.48495 4.3291 7.03141 4.92763 5.95576 5.99434C4.88011 7.06104 4.26948 8.50954 4.25684 10.0244C4.25671 10.2875 4.27448 10.5504 4.31004 10.8112C4.5003 9.43741 5.18117 8.17886 6.22695 7.26793C7.27272 6.357 8.61276 5.85519 9.99964 5.85517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.7676C13.1719 15.7676 15.7432 13.1963 15.7432 10.0245C15.7432 6.85257 13.1719 4.28125 10 4.28125C6.82815 4.28125 4.25684 6.85257 4.25684 10.0245C4.25684 13.1963 6.82815 15.7676 10 15.7676Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5556_14550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoicesIcon);
export default __webpack_public_path__ + "static/media/multiple-choices-icon.38411fe302e8ec6073251a6a0052f64a.svg";
export { ForwardRef as ReactComponent };